// matchSlice.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"; 
import config from "../../../../../config";

export const matchesApi = createApi({
  reducerPath: "matchesApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${config.baseURL}/api/matches` }),
  tagTypes: ['Visitors'], // Add this for cache invalidation
  endpoints: (builder) => ({
    getUsersByLookingFor: builder.query({
      query: ({ id, looking_for }) => `suggestions?user_id=${id}&looking_for=${looking_for}`,
      providesTags: ['Visitors'], // Add this tag
    }),
    // Optional: Add mutation to invalidate cache
    refreshVisitors: builder.mutation({
      query: () => '',
      invalidatesTags: ['Visitors'], // This will auto-refresh queries with 'Visitors' tag
    }),
  }),
});

// Export the hooks
export const { 
  useGetUsersByLookingForQuery, 
  useRefreshVisitorsMutation // Optional: if you want manual refresh
} = matchesApi;






// import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"; 
// import config from "../../../../../config";

// export const matchesApi = createApi({
//   reducerPath: "matchesApi",
//   baseQuery: fetchBaseQuery({ baseUrl: `${config.baseURL}/api/matches` }),
//   endpoints: (builder) => ({
//     getUsersByLookingFor: builder.query({
//       query: ({ id, looking_for }) => `suggestions?id=${id}&looking_for=${looking_for}`,
//     }),
//   }),
// });

// // Export the hook like this:
// export const { useGetUsersByLookingForQuery } = matchesApi;
